<template>
  <v-card
    id="encours"
    fluid
  >
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">{{title}}</span>

  </v-card-title>
  
<v-banner></v-banner>


<v-card> 
  <v-row align="baseline">
    <v-col cols="12" md="3">

      <v-select
          :items="modes"
          label="Mode de Recherche"
          v-model="mode_choisi"
          dense
        ></v-select>


    </v-col>
    <v-col cols="12" md="3">



    </v-col>
    <v-col cols="12" md="3">

    </v-col>
    <v-col cols="12" md="3">

    </v-col>
  </v-row>
</v-card>

<v-card v-if="mode_choisi  == 'Dernières données' "> 
  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="N"
        v-model="N_Dernieres"
        type="number"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-select
          :items="Unites"
          label="Choisir une Unitées de Temps"
          v-model="Unite"
          dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="3">
      <v-btn
        elevation="2"
        :disable="je_cherche"
        :loading="je_cherche"
        color="success"
        @click="Rechercher_Dernieres"
      >Rechercher</v-btn>

    </v-col>
    <v-col cols="12" md="3">

    </v-col>
  </v-row>
</v-card>

<v-card v-if="mode_choisi  == 'Interval de dates' "> 
  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="Date de début"
        v-model="start_date"
        type="date"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Heure de début"
        v-model="start_time"
        type="time"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">

    </v-col>
    <v-col cols="12" md="3">

    </v-col>
  </v-row>
  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="Date de fin"
        v-model="end_date"
        type="date"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Heure de fin"
        v-model="end_time"
        type="time"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-btn
        elevation="2"
        :disable="je_cherche"
        :loading="je_cherche"
        color="success"
        @click="Rechercher_Interval"
      >Rechercher</v-btn>
    </v-col>
    <v-col cols="12" md="3">

    </v-col>
  </v-row>
</v-card>

<v-card v-if="mode_choisi  == 'Depuis une date' "> 
  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="Date de départ"
        v-model="start_date"
        type="date"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Heure de départ"
        v-model="start_time"
        type="time"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">

    </v-col>
    <v-col cols="12" md="3">

    </v-col>
  </v-row>
  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="N"
        v-model="N_Dernieres"
        type="number"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-select
          :items="Unites"
          label="Choisir une Unitées de Temps"
          v-model="Unite"
          dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="3">
      <v-btn
        elevation="2"
        :disable="je_cherche"
        :loading="je_cherche"
        color="success"
        @click="Rechercher_Depuis"
      >Rechercher</v-btn>
    </v-col>
    <v-col cols="12" md="3">

    </v-col>
  </v-row>
</v-card>
<template>
  <v-data-table
    :headers="headers"
    :items="datas"
    :items-per-page="5"
    class="elevation-1"
  ></v-data-table>
</template>

</v-card>
</template>
<script>
  
  export default {

    data: () =>({

      datas :[],
      headers: [
          {
            text: 'ts',
            align: 'start',
            sortable: true,
            value: 'ts',
          },
          { text: 'st', value: 'st' },
          { text: 'ah', value: 'ah' },
          { text: 'ra', value: 'ra' },
          { text: 'dec', value: 'dec' },
          { text: 'nsex', value: 'nsex' },        
          { text: 'res', value: 'res' },

        ],
      title : "SKYPROBE Datas",
      N_Dernieres : 1,
      Unite:"Minutes",
      Unites:['Semaines','Jours','Heures','Minutes'],
      modes: ['Dernières données', 'Interval de dates','Depuis une date'],
      mode_choisi : 'Dernières données',

      start_time : null,
      start_date :null,

      je_cherche : false,

      end_time : null,
      end_date :null,
      url :"",
      data:{},

    }),
  initialize(){

  },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){

  /*  this.get_Target();
    this.load_Target();
    this.A_Update_target = setInterval(() => {
      this.get_Target();
      this.load_Target();
    },2000);*/
  },

  methods: {
    Rechercher_Interval(){
      this.je_cherche = true;

      const othis=this;
        
        othis.url = "";
        othis.url = backend_url + "/Skyprobe/Find_Between/";
        othis.data = {};
        othis.data.start_date = othis.start_date;
        othis.data.start_time = othis.start_time,
        othis.data.end_date = othis.end_date;
        othis.data.end_time = othis.end_time,
        othis.data.start  = "" + othis.data.start_date + "T" +  othis.data.start_time + ":00.000Z";
        othis.data.end  = "" + othis.data.end_date + "T" +  othis.data.end_time + ":00.000Z";

        

        this.axios.post(othis.url,othis.data)
        .then((res) => {

          //console.log(res);

          othis.datas = res.data.data;
          

          othis.je_cherche = false;

        })
        .catch((error) => {

          console.error(error);
          console.log("PB get -> Find_Between");
          //this.loading_ot = false;
          othis.je_cherche = false;
        });

    },
    Rechercher_Dernieres(){
      this.je_cherche = true;

      const othis=this;
        
        othis.url = "";
        othis.url = backend_url + "/Skyprobe/Find_Lasts/";
        othis.data = {};
        othis.data.unit = othis.Unite;
        othis.data.n = othis.N_Dernieres,
        othis.data.start_date = othis.start_date,
        othis.data.start_time = othis.start_time,

        //console.log(othis.data);
        this.axios.post(othis.url,othis.data)
        .then((res) => {

          //console.log(res);

          othis.datas = res.data.data;
          

          othis.je_cherche = false;

        })
        .catch((error) => {

          console.error(error);
          console.log("PB get -> Find_Lasts");
          //this.loading_ot = false;
          othis.je_cherche = false;
        });

    },
    Rechercher_Depuis(){
      this.je_cherche = true;
      console.log("depuis");
      this.je_cherche = false;
    },

  }
}
</script>